<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("comentario", 2) }}
        </h1>
      </div>
    </div>
    <FeedbackTable />
  </div>
</template>

<script>
import FeedbackTable from './components/FeedbackTable.vue';

export default {
  components: { FeedbackTable },
};
</script>
